export default function DatapointDisplayListController(
	$state,
	$stateParams,
	gettextCatalog,
	DatapointdisplayObjects,
	DatapointdisplayService
) {
	'ngInject';

	var vm = this;

	//Bounded variables
	vm.loaded = false;
	vm.loading = false;
	vm.chartTypeOptions = DatapointdisplayObjects.getChartTypes();
	vm.aggregateFunctions = DatapointdisplayObjects.getAggregateFunctions();
	vm.datapointDisplayStatus = null;
	vm.packagesTable = {};
	vm.modulesTable = {};
	vm.error = '';
	vm.applyingModule = false;
	vm.datapointList = [];
	vm.data = { selectedModules: [], selectedPackage: null };
	vm.modulesListForPackage = [];
	vm.datapointsTitleMap = {};

	//local variables
	var datapointDisplayListData = {};

	// Bounded functions
	vm.toggleAggregate = toggleAggregate;
	vm.applyModule = applyModule; //apply the configuration
	vm.onSelectedPackageChange = onSelectedPackageChange;
	vm.onSelectedModuleChange = onSelectedModuleChange;

	//init
	vm.$onInit = init;

	function toggleAggregate(datapointItem, aggregate) {
		datapointItem.aggregates = DatapointdisplayService.toggleAggregate(datapointItem.aggregates, aggregate.value);
	}

	function getSelectedPackageId() {
		return vm.data.selectedPackage;
	}

	function getSelectedModuleIds() {
		var moduleIds = [];

		for (var i = 0; i < vm.data.selectedModules.length; i++) {
			moduleIds.push(vm.data.selectedModules[i].id);
		}
		return moduleIds;
	}

	function onSelectedPackageChange() {
		vm.data.selectedModules = [];

		var selectedPackage = getSelectedPackageId();
		var selectedModules = getSelectedModuleIds();

		vm.modulesListForPackage = DatapointdisplayService.getModulesForPackage(
			selectedPackage,
			vm.packagesTable,
			vm.modulesTable
		);

		vm.datapointList = DatapointdisplayService.getDatapointListForPackageAndModules(
			selectedPackage,
			selectedModules,
			datapointDisplayListData.data,
			vm.packagesTable,
			vm.modulesTable
		);

		//update the status
		// //vm.datapointDisplayStatus = DatapointdisplayService.getDatapointListStatus(vm.datapointList);

		if (selectedPackage) {
			updateStateParams();
		}
	}

	function onSelectedModuleChange() {
		var selectedModules = getSelectedModuleIds();

		var selectedPackage = getSelectedPackageId();

		if (vm.data.selectedModules) {
			updateStateParams();
			vm.datapointList = DatapointdisplayService.getDatapointListForPackageAndModules(
				selectedPackage,
				selectedModules,
				datapointDisplayListData.data,
				vm.packagesTable,
				vm.modulesTable
			);

			//update the status
			vm.datapointDisplayStatus = DatapointdisplayService.getDatapointListStatus(vm.datapointList);
		}
	}

	function applyModule() {
		if (vm.applyingModule) {
			return;
		}

		vm.applyingModule = true;

		var selectedPackageIds = getSelectedPackageId();

		var selectedModuleIds = getSelectedModuleIds();

		DatapointdisplayService.saveDatapointdisplay(selectedPackageIds, selectedModuleIds, vm.datapointList)
			.then(
				function(response) {
					datapointDisplayListData.data = DatapointdisplayService.updateCashedDatapointdisplayData(
						datapointDisplayListData.data,
						response.data.data
					);

					//update lookup tables
					setLookupTables();

					//update datapoint list
					vm.datapointList = DatapointdisplayService.getDatapointListForPackageAndModules(
						selectedPackageIds,
						selectedModuleIds,
						datapointDisplayListData.data,
						vm.packagesTable,
						vm.modulesTable
					);

					//update the status
					vm.datapointDisplayStatus = DatapointdisplayService.getDatapointListStatus(vm.datapointList);
				},
				function(error) {}
			)
			.finally(function() {
				vm.applyingModule = false;
			});
	}

	function setLookupTables() {
		vm.packagesTable = DatapointdisplayService.createPackagesLookupTable(datapointDisplayListData.included);

		vm.modulesTable = DatapointdisplayService.createModulesLookupTable(datapointDisplayListData.included);
	}

  function updateStateParams() {
    if (vm.loaded) {
      const selectedPackageId = getSelectedPackageId();
      const selectedModuleIds = getSelectedModuleIds();
      //if different do this:
      if ($stateParams.packageId !== selectedPackageId || $stateParams.moduleIds !== selectedModuleIds) {
        var params = {
          packageId: selectedPackageId,
          moduleIds: selectedModuleIds
        };
        $state.go('.', params);
      }
    }
  }


  function loadStateParams() {
    var param = {
      packageId: $stateParams.packageId,
      moduleIds: $stateParams.moduleIds
    };
    vm.data.selectedPackage = param.packageId;

    if (param && param.packageId) {
      vm.onSelectedPackageChange();
    }

    if (param && param.moduleIds) {
      if (Array.isArray(param.moduleIds)) {
        for (var i = 0; i < param.moduleIds.length; i++) {
          vm.data.selectedModules.push({
            id: param.moduleIds[i]
          });
        }
      } else {
        vm.data.selectedModules.push({
          id: param.moduleIds
        });
      }
      vm.onSelectedModuleChange();
    }
  }

	function init() {
		vm.loading = true;
		DatapointdisplayService.getAllDatapointDisplayList()
			.then(
				function(response) {
					datapointDisplayListData = response.data;

					setLookupTables();

					vm.loaded = true;

					vm.datapointsTitleMap = DatapointdisplayService.CreateDatapointMapObject();
					loadStateParams();
				},
				function(response) {
					vm.error = gettextCatalog.getString('Error getting datapoint list' + response.data);
				}
			)
			.finally(function(response) {
				vm.loading = false;
			});
	}
}
